<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h6 d-flex justify-space-between">
          Selecione as colunas
          <v-btn
            icon
            @click="dialog=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  v-model="selected"
                  :items="items"
                  label="Colunas"
                  return-object
                  multiple
                  hint="Escolha as colunas"
              ></v-select>
            </v-col>
            
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-col cols="12 ">
            <v-btn
              block
              class="red darken-2 white--text fill-witdh"
              :loading="loading"
              :disabled="list.length == 0"
              @click="generatePDF()"
            >
              <v-icon
              right
              dark
            >
              mdi-file-pdf-box
            </v-icon>
              <span class="px-5">Gerar PDF</span>
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      class="red darken-2 white--text  mx-0 ml-sm-2"
      :loading="loading"
      :disabled="list.length == 0"
      @click="dialog = true"
    >
      <v-icon
      right
      dark
    >
      mdi-file-pdf-box
    </v-icon>
      <span class="px-5">Gerar PDF</span>
    </v-btn>
  </div>
  
</template>
<script>
  import autoTable from 'jspdf-autotable'
  import { jsPDF } from 'jspdf';
  export default {
    props: {
      orderByProps:{
        required: false,
        type: String,
        default: null
      },
      showQuantidade:{
        required: false,
        type: Boolean,
        default: false
      },
      items: {
        required: true,
        type: Array
      },
      options:{
        required: false,
        type: Object,
        default: ()=>{
          return {}
        }
      },
      list:{
        required: false,
        type: Array,
        default: ()=>{
          return []
        }
      }
    },
    data: () => {
      return {
        selected: [],
        loading: false,
        dialog: false
      };
    },
    methods:{
      dateFormatted(){
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();
        return `${dd}-${mm}-${yyyy}`
      },
      async orderBy(a , b, propName){
        if ( a[propName] < b[propName] ){
          return -1;
        }
        if ( a[propName] > b[propName] ){
          return 1;
        }
        return 0;
      },
      async generatePDF(){
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'in',
          format: 'letter'
        });
        if(this.orderByProps){
          this.list = this.list.sort((a , b)=>{
            if ( a[this.orderByProps] < b[this.orderByProps] ){
              return -1;
            }
            if ( a[this.orderByProps] > b[this.orderByProps] ){
              return 1;
            }
            return 0;
          })
        }
        
        const columns = this.selected.map((item)=>{
          return {
            title: item.text,
            dataKey: item.value
          }
        })

        if(this.showQuantidade){
          this.list.push({
            [columns[0].dataKey]: 'Quantidade de registros',
            [columns[columns.length - 1].dataKey]: this.list.length
          })
        }
        

        doc.setFontSize(12).text('RELATÓRIO', 0.5, 0.45);
        doc.setFontSize(12).text('SISTEMA DE GESTÃO - CONSTRUTORA MK & REPRESENTAÇÕES', 0.5, 0.65);
        doc.setFontSize(12).text('GESTÃO E ADMINISTRAÇÃO', 0.5, 0.85);
        const nowDate = new Date();
        doc.setFontSize(14).text(`${this.options.title} - Manaus(AM), ${this.formatDate((nowDate).toISOString())} às ${nowDate.toTimeString().slice(0, 8)}`, 0.5, 1.7);
        doc.setLineWidth(0.01).line(0.5, 1.8, 10.4, 1.8);
        autoTable(doc, {
          columns,
          body: this.list,
          margin: { left: 0.5 },
          startY: 2.15,
          styles:{
            font: '10px'
          }
        })
        doc.save(`${this.options.docName}_${this.dateFormatted()}.pdf`);
      },
      formatDate (dateCustom) {
        if(dateCustom){
          const date = dateCustom.substring(0,10)
          const [year, month, day] = date.split('-');

          const result = [day, month, year].join('/');
          return result;
        }
      }
    }
  };
</script>